import { useEffect, useRef, useState } from "react";
import { Download, Loader2, Paperclip, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, download, errMsg } from "@/lib/api";

export const PreuvesBooking = ({ actif }) => {
  const [liste, setListe] = useState(null);
  const [busy, setBusy] = useState(false);
  const input = useRef(null);
  const load = () => api.get("/fichiers/preuves-booking").then((r) => setListe(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);
  const deposer = async (file) => {
    if (!file) { return; }
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    try { await api.post("/fichiers/preuves-booking", fd); toast.success(`Preuve « ${file.name} » ajoutée`); load(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); input.current.value = ""; }
  };
  const supprimer = async (p) => {
    if (!window.confirm(`Supprimer la preuve « ${p.nom} » ?`)) { return; }
    try { await api.post("/fichiers/supprimer", { ids: [p.id] }); toast.success("Preuve supprimée"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="mt-4 border-t border-slate-100 pt-4" data-testid="preuves-booking">
      <div className="flex flex-wrap items-center gap-2">
        <p className="text-sm font-medium text-slate-800">Preuves que Booking remet la taxe</p>
        <input ref={input} type="file" accept=".pdf,.png,.jpg,.jpeg,.webp,application/pdf,image/*" className="hidden" onChange={(e) => deposer(e.target.files[0])} data-testid="preuve-booking-input" />
        <Button size="sm" variant="outline" className="ml-auto h-8" disabled={busy} onClick={() => input.current.click()} data-testid="preuve-booking-ajouter">
          {busy ? <Loader2 className="h-3.5 w-3.5 mr-1 animate-spin" /> : <Paperclip className="h-3.5 w-3.5 mr-1" />}Ajouter une preuve
        </Button>
      </div>
      <p className="mt-1 text-[11px] text-slate-500">PDF ou image (capture du compte Booking, courriel enregistré en PDF). Conservées dans Fichiers › Preuves Booking et ajoutées en annexe à la fin du bilan PDF {actif ? "" : "dès que le réglage ci-dessus est activé"}.</p>
      {liste === null ? <Loader2 className="mt-2 h-4 w-4 animate-spin text-emerald-700" /> : (
        <ul className="mt-2 space-y-1" data-testid="preuves-booking-liste">
          {liste.map((p) => (
            <li key={p.id} className="flex items-center gap-2 text-xs text-slate-700" data-testid={`preuve-${p.id}`}>
              <span className="truncate">{p.nom}</span><span className="text-slate-400">· {p.importe_le.slice(0, 10)}</span>
              <button type="button" className="ml-auto text-slate-500 hover:text-emerald-700" onClick={() => download(`/fichiers/${p.id}/telecharger`, {}, p.nom).catch((e) => toast.error(errMsg(e)))} data-testid={`preuve-telecharger-${p.id}`}><Download className="h-3.5 w-3.5" /></button>
              <button type="button" className="text-slate-400 hover:text-red-600" onClick={() => supprimer(p)} data-testid={`preuve-supprimer-${p.id}`}><Trash2 className="h-3.5 w-3.5" /></button>
            </li>
          ))}
          {!liste.length && <li className="text-xs text-slate-400" data-testid="preuves-booking-vide">Aucune preuve déposée.</li>}
        </ul>
      )}
    </div>
  );
};
